import React, { useContext } from "react";
import { AppContext } from "../AppContextProvider";
import close from "../assets/media/icons/cross-thin.svg";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function MessageModal(props) {
  const context = useContext(AppContext);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="email-modal">
        <MDBModalDialog scrollable centered size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <span className="title-text">Message</span>
              </MDBModalTitle>
              <MDBBtn className="button subtle large" type="button" onClick={props.hideModal}>
                <img src={close} alt="close" />
              </MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="text-value-2">{context.getState()?.modalText}</div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
